import React, { FC } from 'react';
import { Container, Form } from 'react-bootstrap';
import { Button } from '../../atoms';
import { UserUsage } from '../../../store/contextAPI/user/user-usage';
import { CustomDropdown } from '../../molecules';
import { UserDetailsDto } from '../../../store/contextAPI/user/dto/response/user-details.dto';
import styles from './UserManagementUsersDetailsForm.module.css';

interface UserManagementUsersDetailsFormProps {
  data: UserDetailsDto;
  handleOnChange: (user: UserDetailsDto) => void;
  callbackFn: (user: UserDetailsDto) => void;
}

interface DropDownItem {
  eventKey: string;
  label: string;
}

const UserManagementUsersDetailsForm: FC<
  UserManagementUsersDetailsFormProps
> = ({ data, handleOnChange, callbackFn }) => {
  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn(data);
  };

  const usageItems: DropDownItem[] = Object.values(UserUsage).map((value) => {
    return {
      eventKey: value,
      label: value,
    };
  });

  return (
    <Container className={styles.form}>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={data.name ?? ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                name: e.target.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="text"
            disabled={true}
            value={data.email ?? ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                email: e.target.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Name of organization</Form.Label>
          <Form.Control
            type="text"
            value={data.companyName ?? ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                companyName: e.target.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>What would you like to use SourceUp for?</Form.Label>
          <CustomDropdown
            initialTitle={data?.usage?.toString() ?? ''}
            items={usageItems}
            onSelectOption={(dropdownItem) => {
              const usage =
                UserUsage[dropdownItem.eventKey as keyof typeof UserUsage];
              handleOnChange({
                ...data,
                usage: usage,
              });
            }}
          />
        </Form.Group>

        <Button variant={'dark'} onClick={handleSubmit}>
          Save
        </Button>
      </Form>
    </Container>
  );
};

export default UserManagementUsersDetailsForm;
